module.exports = __webpack_public_path__ + "img/clinique_logo.2e6cabb6.png";